export enum RecordTypeEnum {
  HABITS = 'HABITS',
  PHYSICAL_ACTIVITY = 'PHYSICAL_ACTIVITY',
  PERSONAL_MEDIC = 'PERSONAL_MEDIC',
  FAMILIAL_MEDICAL = 'FAMILIAL_MEDICAL',
  NUTRITIONAL = 'NUTRITIONAL',
  NUTRITIONAL_PHYSICAL_EXAMINATION = 'NUTRITIONAL_PHYSICAL_EXAMINATION',
  SLEEP = 'SLEEP',
  ENVIRONMENT_AFFECTIVITY = 'ENVIRONMENT_AFFECTIVITY',
  ATTITUDE = 'ATTITUDE',
  BIOCHEMISTS = 'BIOCHEMISTS',
  MY_EXPERIENCE = 'MY_EXPERIENCE',
  MEAL_PLAN = 'MEAL_PLAN',
  DIAGNOSTIC = 'DIAGNOSTIC',
  MINI_SPHERE = 'MINI_SPHERE'
}

